import { render, staticRenderFns } from "./LandlordLists.vue?vue&type=template&id=183941a6&scoped=true"
import script from "./LandlordLists.vue?vue&type=script&lang=js"
export * from "./LandlordLists.vue?vue&type=script&lang=js"
import style0 from "./LandlordLists.vue?vue&type=style&index=0&id=183941a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183941a6",
  null
  
)

export default component.exports